// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"1591f3f9","741":"1591f3f9","3122":"1591f3f9","3888":"1591f3f9","5258":"0c6f5e0c","6154":"3d7c473d","7015":"1c422664"}[chunkId] + ".chunk.css";
};